import React, { Component } from "react";
import { withRedux } from "helpers";
import { Form, FlexRow, H2, Button, P } from "appStyles";
import { SaveProgress, RadioOptions } from "components";
import EditBackground from "../EditBackground";
import "@material/radio/dist/mdc.radio.css";
import "@material/form-field/dist/mdc.form-field.css";
import Modal from "@material-ui/core/Modal";
import AdvStore from "./AdvStore";
import { css } from "react-emotion";
import { storeRedemptionTypeOptions } from "constants";
import { imageView } from "defaultStates";
import { getAdvancedStoreTemplate } from "apis";
import SettingsIcon from "@material-ui/icons/Settings";
import AddCircleIcon from "@material-ui/icons/AddCircle";

const container = css`
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  padding: 20px;
  position: relative;
  padding: 1em;
  border-radius: 5px;
  margin-bottom: 3em;
  margin-top: 1em;
`;

class StoreSettings extends Component {
  state = {
    croppingAspectRatio: "1.0",
    showAdvancedSettingsModal: false,
    advancedSettings: null,
  };
  constructor(props) {
    super(props);
  }

  update = (field) => (value) => {
    // console.log("updating with field: " + field + " and value: " + value);
    this.props.actions.updateApplication(field, value);
  };

  updatePic = (field) => (value) => {
    this.setState({ [field]: value });
  };

  addTempStoreItem = () => {
    this.props.actions.addTempStoreItem();
    this.props.actions.updateActiveEditor("newStoreItem");
    // this.setState({ showModal: true });
  };

  getAdvancedSettings = async (appId, templateId) => {
    try {
      const result = await getAdvancedStoreTemplate(appId, templateId);
      // this.setState({ advancedSettings: result });
      return result;
      // console.log(this.state.advancedSettings);
    } catch (e) {
      console.error(e);
    }
  };

  hasDeal = () => Object.keys(this.props.deals).length > 0;
  // updateComponent = component => {
  //   const { activeTemplate } = this.props;
  //   const updatedTemplate = {
  //     ...this.props.activeTemplate
  //   };
  //   updatedTemplate.components = activeTemplate.components.map(c =>
  //     c.componentNumber === component.componentNumber ? component : c
  //   );
  //   this.props.actions.updateTemplate(updatedTemplate);
  // };
  updateBackgroundColor = (backgroundColor) => {
    const updatedTemplate = {
      ...this.props.activeTemplate,
      backgroundColor,
    };

    this.props.actions.updateTemplate(updatedTemplate);
  };

  updateBackgroundImage = (url) => {
    let updatedTemplate = this.props.activeTemplate;
    if (url) {
      if (updatedTemplate.backgroundImage === null) {
        updatedTemplate = {
          ...this.props.activeTemplate,
          backgroundImage: imageView(url),
        };
      } else {
        updatedTemplate = {
          ...this.props.activeTemplate,
          backgroundImage: {
            ...this.props.activeTemplate.backgroundImage,
            url,
          },
        };
      }
    } else {
      updatedTemplate = {
        ...this.props.activeTemplate,
        backgroundImage: null,
      };
    }

    this.props.actions.updateTemplate(updatedTemplate);
  };

  renderPageSettings = () => {
    // if (!this.hasDeal()) return null;
    const { activeApp, activeTemplate, activeEditor } = this.props;
    const { croppingAspectRatio } = this.state;
    return (
      <div className={container}>
        <EditBackground
          croppingAspectRatio={croppingAspectRatio}
          update={this.updatePic}
          updateComponent={this.updateComponent}
          pictureCatalogComponent={
            activeTemplate.type === "pictureCatalog"
              ? activeTemplate.components[0]
              : false
          }
          updateBackgroundColor={this.updateBackgroundColor}
          updateBackgroundImage={this.updateBackgroundImage}
          backgroundColor={activeTemplate.backgroundColor}
          backgroundImage={activeTemplate.backgroundImage}
          additionalPageSettings={this.additionalPageSettings}
          appId={activeApp.id}
        />
        <SaveProgress />
      </div>
    );
  };
  renderAdvancedSettingsButton = () => {
    return (
      <Button
        onClick={this.toggleAdvancedSettingsModal}
        className="advancedSettingButton"
        style={{
          display: "inline-block",
          width: "180px",
          textAlign: "center",
          fontSize: "15px",
          lineHeight: "normal",
          borderRadius: "5.5px",
          fontWeight: "bold",
          boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
          fontStyle: "normal",
          fontStretch: "normal",
          textTransform: "none",
          backgroundColor: "#89d2d3",
          padding: "15px",
          margin: "10px",
        }}
      >
        Advanced Settings
      </Button>
    );
  };

  toggleAdvancedSettingsModal = async () => {
    const { showAdvancedSettingsModal, advancedSettings } = this.state;
    const {
      activeApp: { id: appId },
      activeTemplate: { id: templateId },
    } = this.props;

    // console.log("appId : " + appId + "\ntemplateId: " + templateId);
    if (!showAdvancedSettingsModal) {
      const result = await this.getAdvancedSettings(appId, templateId);
      this.setState({ advancedSettings: result });
    }

    this.setState({ showAdvancedSettingsModal: !showAdvancedSettingsModal });
  };

  renderAdvancedSettingsModal = () => {
    const { showAdvancedSettingsModal, advancedSettings } = this.state;
    const {
      activeApp: { id: appId },
      activeTemplate: { id: templateId },
    } = this.props;
    const { featuresRedemptionType } = this.props.activeApp;
    if (!showAdvancedSettingsModal) return null;
    return (
      <Modal
        open={showAdvancedSettingsModal}
        onClose={this.toggleAdvancedSettingsModal}
        style={{
          margin: "auto",
          width: "50%",
          top: "4%",
          overflowY: "auto",
        }}
      >
        <AdvStore
          toggleAdvancedSettingsModal={this.toggleAdvancedSettingsModal}
          advancedSettings={advancedSettings}
          appId={appId}
          templateId={templateId}
          featuresRedemptionType={featuresRedemptionType}
          props={this.props}
        />
      </Modal>
    );
  };
  renderTerms = () => {
    return (
      <React.Fragment>
        <div>
          <div
            style={{
              display: "flex",
              width: "350px",
              alignItems: "center",
            }}
          >
            <H2
              fontSize="20px"
              lineHeight="29px"
              className="dealRedemption"
              fontWeight="normal"
              margin="0px"
            >
              Terms and Conditions
            </H2>
          </div>
        </div>
        <p
          style={{
            fontSize: "12px",
            lineHeight: "14px",
            color: "#8C8C8C",
            margin: "15px 5px",
          }}
          className="dealPassword"
        >
          While we don’t anticipate any issues, Please note Mobile360 simply
          serves as the payment processing mechanism that allows you sell items
          through your app. You are fully responsible for fulfilling your
          customers orders, including any disputes, refutations, or refund
          requests by your customers. Mobile360 will make periodic payouts to
          your the bank account information you have provided. If the customer
          disputes any credit card transaction, you will be charged the amount
          if Mobile360 has already made a payout for said transaction, and will
          be responsible with working with credit card company to handle
          dispute. By using this in your app, you agree to all terms and
          conditions.
        </p>
      </React.Fragment>
    );
  };
  renderFeaturesRedemptionType = () => {
    // if (!this.hasDeal()) return null;

    const { featuresRedemptionType } = this.props.activeApp;
    const { activeApp } = this.props;
    const isManual = featuresRedemptionType == 1;
    const isCustomerScans = featuresRedemptionType == 2;
    return (
      <React.Fragment>
        <div>
          <div
            style={{
              display: "flex",
              width: "350px",
              alignItems: "center",
              margin: "15px 0px",
            }}
          >
            <H2
              fontSize="25px"
              lineHeight="29px"
              className="dealRedemption"
              fontWeight="normal"
              margin="0px"
            >
              Store Item Redemption Type
            </H2>
          </div>
        </div>
        <p
          style={{
            fontSize: "12px",
            lineHeight: "14px",
            color: "#8C8C8C",
            margin: "15px 5px",
          }}
          className="dealPassword"
        >
          Select how customers can redeem their purchases in the app
        </p>
        <FlexRow width="100%" height="auto">
          <RadioOptions
            {...this.props}
            // value={redemptionType}
            value={featuresRedemptionType}
            options={storeRedemptionTypeOptions}
            setValue={this.update("featuresRedemptionType")}
            showPasswordInput={isManual}
            showQRCode={isCustomerScans}
            pageType="featuresRedemption"
          ></RadioOptions>
        </FlexRow>
      </React.Fragment>
    );
  };

  updatePageName = (pageName) => {
    const updatedTemplate = {
      ...this.props.activeTemplate,
      pageName,
    };
    this.props.actions.updateTemplate(updatedTemplate);
  };

  render() {
    const hasNewDeal = this.props.deals.newDeal;
    const {
      store,
      activeEditor,
      activeApp: { id },
    } = this.props;

    // const activeStore = store[activeEditor];

    return (
      <div>
        {this.renderPageSettings()}
        <Form marginBottom="3em">
          <div
            style={{
              padding: "1em 0em",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <P
              style={{
                color: "black",
                fontSize: "24px",
                fontWeight: "bold",
                fontStyle: "normal",
                fontStretch: "normal",
                lineHeight: "normal",
                letterSpacing: "2px",
                textTransform: "none",
                width: "100%",
                textAlign: "left",
              }}
            >
              Store Management
            </P>
            <span
              style={{
                cursor: "pointer",
                fontSize: "12px",
                lineHeight: "14px",
                color: "#8C8C8C",
              }}
              onClick={this.toggleAdvancedSettingsModal}
            >
              <SettingsIcon fontSize="large" />
            </span>
          </div>

          {this.renderAdvancedSettingsModal()}
          <div style={{ textAlign: "center" }}>
            <Button
              onClick={this.addTempStoreItem}
              className="newDealButton"
              style={{
                marginLeft: " 0px",
                marginBottom: "40px",
                display: "inline-flex",
                alignItems: "center",
                textAlign: "center",
                fontSize: "15px",
                lineHeight: "29px",
                borderRadius: "5.5px",
                backgroundColor: "#89d2d3",
                fontWeight: "bold",
                boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
                fontStyle: "normal",
                fontStretch: "normal",
                textTransform: "none",
              }}
            >
              <AddCircleIcon style={{ marginRight: "5px" }}></AddCircleIcon>
              Create New Store Item
            </Button>
          </div>
          {this.renderTerms()}
          {/* <SaveProgress /> */}
        </Form>
      </div>
    );
  }
}

export default withRedux(StoreSettings);
